export const CS_ISSUE_API_UNAVAILABLE_MESSAGE = 'CS 문의 API를 준비 중입니다.'

export function isCSIssueApiEnabled(value) {
  return String(value || '').trim().toLowerCase() === 'true'
}

export function createCSIssueApiUnavailableError() {
  const error = new Error(CS_ISSUE_API_UNAVAILABLE_MESSAGE)
  error.code = 'CS_ISSUE_API_UNAVAILABLE'
  return error
}
